import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { PostAxios, TokenExpireOnAPIRequest } from "../Services/RequestService";
import { setMainLoading, toggleSideNav } from "../Store/reducers/Common";
import { logoutUser } from "../Store/reducers/Users";
import { setToastData } from "../Store/reducers/Toast";
import { ConvertErrorArrayToString } from "../Services/Common";
import { formatDate } from "../Services/DateFunc";

export default function Header() {
  const location = useLocation();
  const { userData, accessToken } = useSelector((state) => state.user);
  const [userDrop, setUserDrop] = useState(false);
  const [notiDrop, setNotiDrop] = useState(false);
  const [alreadyFetchingNoti, SetFetchingNoti] = useState(false);
  const [notiCount, setNotiCount] = useState(0);
  const [notiList, setNotiList] = useState([]);
  const userDropRef = useRef(null);
  const notiDropRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const parseNotificationMessage = (notification) => {
    if (notification?.message) return notification.message;
    try {
      const parsedData =
        typeof notification?.notification_data === "string"
          ? JSON.parse(notification.notification_data)
          : notification?.notification_data || {};
      return parsedData?.message || parsedData?.title || "New notification";
    } catch (error) {
      return "New notification";
    }
  };
  const onLogout = () => {
    dispatch(setMainLoading(true));
    PostAxios(
      `logout`,
      {
        user_id: userData.id,
      },
      accessToken
    )
      .then(({ data }) => {
        if (data.status === "1") {
          dispatch(logoutUser());
        }
        else if (data.error === "1") {
          dispatch(setToastData(
            {
              title:'Error',
              message: (data.errors)?ConvertErrorArrayToString(data.errors):data.message,//`${data.message} <br /> `,
              isHtml: true,
              type: "error",
              showCloseBtn: true,
            }
          ))
        }
      })
      .catch((err) => {
        console.log(err);
      }).finally(()=>{
        dispatch(setMainLoading(false));
      });
  };
  const fetchNotifications = () => {
    if (alreadyFetchingNoti === false) {
      SetFetchingNoti(true);
      PostAxios(
        `notification/get-user-notification`,
        {},
        accessToken
      )
        .then(({ data }) => {
          if (data?.code === 401) {
            TokenExpireOnAPIRequest(dispatch, data);
          }
          else if (`${data?.status}` === "1") {
            const list = Array.isArray(data?.data) ? data.data : [];
            const mappedList = list.map((item) => ({
              ...item,
              message: parseNotificationMessage(item),
            }));
            setNotiList(mappedList.slice(0, 5));
            setNotiCount(mappedList.length);
          }
          SetFetchingNoti(false);
        })
        .catch((err) => {
          SetFetchingNoti(false);
        });
    }
  };
  useEffect(() => {
    fetchNotifications();
    const timer = setInterval(() => {
      if (alreadyFetchingNoti === false) {
        fetchNotifications();
      }
    }, 10000);
    return () => clearInterval(timer);
  }, [accessToken, userData.id]);
  useEffect(() => {
    setNotiDrop(false);
  }, [location]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (notiDropRef.current) {
        if (
          notiDropRef.current &&
          !notiDropRef.current.contains(event.target)
        ) {
          setNotiDrop(false);
        }
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [setNotiDrop]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (userDropRef.current) {
        if (
          userDropRef.current &&
          !userDropRef.current.contains(event.target)
        ) {
          setUserDrop(false);
        }
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [setUserDrop]);
  return (
    <header>
      <div className="top-header">
        <div className="logo-sec">
          <Link to={'/'} style={{width:40,lineHeight:0}}>
            <img src={`${process.env.PUBLIC_URL}/images/bg-logo-white.png`} alt="Burhani Guards Indore" />
          </Link>
          <h1>Burhani Guards Indore</h1>
        </div>
        <div className="header-right">
          <div className="search-notify-sec">
            <div className="notification-main" ref={notiDropRef}>
              <button
                onClick={() => {
                  setNotiDrop(!notiDrop);
                }}
                className="notify-sec"
              >
                <i className="fa-regular fa-bell"></i>
              </button>
              <div className={`content-notification`} style={{display: notiDrop ? 'block' : 'none'}}>
                <span className="box-top-arrow"></span>
                <div className="notification-title">Notification</div>
                <ul className="notification-list">
                  {notiList.length > 0 ? (
                    notiList.map((val, index) => (
                      <li
                        key={val.id || `notification-item-${index}`}
                        className={`notification-item ${
                          val.read_status === 0 ? "unread-notification" : ""
                        }`}
                      >
                        <div className="notification-text">{val.message}</div>
                        <div className="notification-date">
                          {formatDate(val.created_at || val.published_date || "")}
                        </div>
                      </li>
                    ))
                  ) : (
                    <li className="notification-item notification-empty">
                      <div className="notification-text">No notifications found</div>
                    </li>
                  )}
                  <li className="notification-footer">
                    <Link to={"/notifications"}>See all notifications <i className="fa-solid fa-arrow-right"></i></Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="right-user-sec" ref={userDropRef}>
            <button onClick={() => setUserDrop(!userDrop)} className="user-icon">
              <i className="fa-regular fa-user"></i>
              <span className="dropdown-menu"><i className="fa-solid fa-chevron-down"></i></span>
            </button>
            <div
              className={`dropdown-content ${userDrop ? 'drop-open' : ''}`}
            >
              <span className="box-top-arrow"></span>
              {/* <div className="logout-btn">
                <Link to={`/reset-password`} title="Reset Password">
                <i className="fa-solid fa-unlock-keyhole"></i> Reset Password
                </Link>
              </div> */}
              <div className="logout-btn">
                <button onClick={onLogout}>
                  <i className="fa-solid fa-power-off"></i> logout
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </header>
  );
}
